import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { MetalTypeEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetSerialNumberListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetSerialNumberListingAttempt', handleGetSerialNumberListing, api);
}

function* handleGetSerialNumberListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { serialNo, metalType } } = reduxState.gold.serialNumber.serialNumberListing;

    const response = yield* call([api, api.getSerialNumberListing], {
        authToken,
        index,
        serialNo: serialNo?.trim() === '' ? undefined : serialNo?.trim(),
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetSerialNumberListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetSerialNumberListingSuccess(response.data));
    }
}
